<template>
  <div
    style="padding: 20px; position: relative; overflow: hidden; height: 100%"
  >
    <div
      style="
        border-radius: 10px;
        overflow: hidden;
        height: 100%;
        display: flex;
        flex-direction: column;
      "
    >
      <ul
        style="
          background-color: #f6f6f6;
          padding: 20px;
          border: 1px solid var(--el-border-color-lighter);
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          border-bottom: 0;
        "
      >
        <ul
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <div style="display: flex; align-items: center">
            <li
              style="
                display: flex;
                align-items: center;
                font-size: 14px;
                font-weight: 600;
              "
            >
              <c_status
                v-if="
                  state.model.status != null && state.model.status != undefined
                "
                arr-name="taxdeclarecorrect_status"
                :value="state.model.status"
              ></c_status>
              <text style="margin-left: 10px">{{ state.model.name }}</text>
            </li>
            <el-popover placement="bottom-end" width="60%" trigger="hover">
              <template #reference>
                <el-icon
                  size="20"
                  color="#1e90ff"
                  style="margin-left: 5px; cursor: pointer"
                >
                  <View />
                </el-icon>
              </template>
              <template #default>
                <div style="font-weight: 600; font-size: 13px">基本信息</div>
                <el-descriptions
                  :column="2"
                  border
                  style="overflow-x: auto; margin-top: 10px"
                  class="desc-label-nowrap"
                >
                  <el-descriptions-item label="名称" label-align="right">
                    {{ state.model.name }}
                  </el-descriptions-item>
                  <el-descriptions-item label="状态" label-align="right">
                    <c_status
                      v-if="
                        state.model.status != null &&
                        state.model.status != undefined
                      "
                      arr-name="taxdeclarecorrect_status"
                      :value="state.model.status"
                    ></c_status>
                  </el-descriptions-item>
                  <el-descriptions-item label="扣缴义务人" label-align="right">
                    {{ state.model.withholding_agent_name || "-" }}
                  </el-descriptions-item>
                  <el-descriptions-item label="更正年份" label-align="right">
                    {{ state.model.year || "-" }}
                  </el-descriptions-item>
                  <el-descriptions-item label="更正人数" label-align="right">
                    {{ state.model.employee_num || "0" }}
                  </el-descriptions-item>
                  <el-descriptions-item label="更正说明" label-align="right">
                    {{ state.model.remark || "-" }}
                  </el-descriptions-item>
                  <el-descriptions-item label="创建人" label-align="right">
                    {{
                      state.model.add_admin_name +
                      "/" +
                      state.model.add_department_name
                    }}
                  </el-descriptions-item>
                  <el-descriptions-item label="创建时间" label-align="right">
                    {{ state.model.create_time }}
                  </el-descriptions-item>
                </el-descriptions>
              </template>
            </el-popover>
          </div>
          <el-button
            type="primary"
            link
            icon="Edit"
            @click="state.showEdit = true"
            v-if="$judge_auth('104')"
          >
            编辑
          </el-button>
        </ul>
      </ul>
      <div
        style="
          overflow: hidden;
          flex: 1;
          border: 1px solid var(--el-border-color-lighter);
          padding: 0 20px;
          display: flex;
          flex-direction: column;
        "
      >
        <el-tabs
          v-model="state.active_month"
          class="detail-tabs"
          style="
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
          "
        >
          <el-tab-pane
            v-for="item in state.month_data"
            :key="item"
            :label="$dayjs(item.skssq).format('M月')"
            :name="item.skssq"
            style="
              flex: 1;
              display: flex;
              flex-direction: column;
              overflow: hidden;
            "
          >
            <div
              style="
                flex: 1;
                padding: 20px 10px 0 10px;
                overflow: hidden;
                display: flex;
                flex-direction: column;
              "
            >
              <ul
                style="
                  display: flex;
                  align-items: center;
                  border-bottom: 1px solid #e2e2e2;
                  padding-bottom: 10px;
                "
              >
                <li
                  style="
                    flex: 1;
                    display: flex;
                    align-items: center;
                    column-gap: 20px;
                  "
                >
                  <el-input
                    v-model="state.params.keywords"
                    style="width: 200px"
                    placeholder="姓名、手机号、证件号"
                    clearable
                    @clear="
                      delete state.params.keywords;
                      onLoad();
                    "
                    @paste.enter="$onKeywordsPaste($event, state.params)"
                  ></el-input>
                  <el-date-picker
                    v-model="state.params.skssq"
                    type="month"
                    placeholder="税款所属期"
                    format="YYYY年M月"
                    value-format="YYYYMM"
                  />
                  <el-dropdown split-button @click="onLoad" type="primary">
                    查询
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item
                          :icon="RefreshLeft"
                          @click="onReset()"
                        >
                          重置
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </li>
                <el-button type="primary">申请更正</el-button>
              </ul>
              <div
                style="
                  flex: 1;
                  overflow-y: auto;
                  padding: 0 5px;
                  margin-top: 10px;
                "
              >
                <div
                  style="
                    box-shadow: 0 0 7px 1px #e2e2e2;
                    margin-top: 5px;
                    border-radius: 7px;
                    margin-bottom: 20px;
                  "
                  v-for="(item, index) in state.employee_data"
                  :key="item"
                >
                  <ul
                    style="
                      border-bottom: 1px solid #e2e2e2;
                      padding: 10px;
                      display: flex;
                      font-size: 90%;
                    "
                  >
                    <li
                      style="
                        flex: 1;
                        display: flex;
                        align-items: center;
                        column-gap: 30px;
                      "
                    >
                      <text style="font-size: 100%; font-weight: 600">{{
                        item.name
                      }}</text>
                      <span>
                        <text style="color: #a2a2a2">入职日期：</text>
                        {{ item.entry_time || "-" }}
                      </span>
                      <span>
                        <text style="color: #a2a2a2">离职日期：</text>
                        {{ item.resignation_time || "-" }}
                      </span>
                      <span>
                        <text style="color: #a2a2a2">身份证号：</text>
                        {{ item.idcard }}
                      </span>
                      <span>
                        <text style="color: #a2a2a2">手机号：</text>
                        {{ item.phone }}
                      </span>
                    </li>
                    <el-checkbox
                      :checked="item.is_resignation"
                      :true-value="1"
                      :false-value="0"
                      size="small"
                      :key="state.key"
                      @change="onDybsbChange(item, $event)"
                    >
                      当月不申报
                    </el-checkbox>
                  </ul>
                  <div
                    v-for="(gzItem, gzIndex) in item.payroll_list"
                    :key="gzItem"
                    style="padding: 10px"
                  >
                    <ul
                      style="display: flex; align-items: center; font-size: 80%"
                    >
                      <text style="font-weight: 600">
                        [{{ gzItem.payroll_order_id }}]
                      </text>
                      <text>{{ gzItem.payroll_name }}</text>
                      <text style="color: #a2a2a2">
                        {{ gzItem.declare_kind + "-" + gzItem.declare_item }}
                      </text>
                    </ul>
                    <table
                      style="
                        border-collapse: collapse;
                        border: 1px solid #f6f6f6;
                        width: 100%;
                        margin-top: 10px;
                        font-size: 80%;
                        text-align: right;
                      "
                      cellpadding="10"
                      border="1"
                    >
                      <thead>
                        <tr>
                          <th>
                            <el-button
                              link
                              type="warning"
                              icon="sort"
                              @click="
                                state.select_name = item.name;
                                state.select_data = gzItem.origin_data;
                                state.employee_index = index;
                                state.gzIndex = gzIndex;
                                state.showChange = true;
                              "
                            >
                              调整金额
                            </el-button>
                          </th>
                          <th v-for="field in state.sortFields" :key="field">
                            {{ field.name }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr style="color: #a2a2a2">
                          <td>历史申报</td>
                          <td v-for="field in state.sortFields" :key="field">
                            {{
                              gzItem.data[field.field] == null ||
                              gzItem.data[field.field] == undefined
                                ? "-"
                                : $priceFormat(gzItem.origin_data[field.field])
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>更正申报</td>
                          <td v-for="field in state.sortFields" :key="field">
                            {{
                              gzItem.origin_data[field.field] == null ||
                              gzItem.origin_data[field.field] == undefined
                                ? "-"
                                : $priceFormat(gzItem.origin_data[field.field])
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td>差值</td>
                          <td
                            v-for="field in state.sortFields"
                            :key="field"
                            :style="{
                              color:
                                gzItem.diff_data[field.field] > 0 ? '#f00' : '',
                            }"
                          >
                            {{
                              gzItem.diff_data[field.field] == null ||
                              gzItem.diff_data[field.field] == undefined
                                ? "-"
                                : $priceFormat(gzItem.diff_data[field.field])
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="修改更正单"
      @close="state.showEdit = false"
    >
      <c_TaxDeclareCorrectEdit
        @close="
          state.showEdit = false;
          onLoad();
        "
        :id="props.data?.id"
      ></c_TaxDeclareCorrectEdit>
    </c_popup>
  </transition>
  <el-dialog
    v-model="state.showChange"
    :title="`调整员工${state.select_name}薪资信息`"
    width="60%"
    align-center
  >
    <c_TaxDeclareCorrectEditEmployee
      :model="state.select_data"
      :sortFields="state.sortFields"
      @confirm="onEditConfirm"
      @close="state.showChange = false"
    >
    </c_TaxDeclareCorrectEditEmployee>
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  taxdeclarecorrect_detail,
  taxdeclarecorrect_taxmonth,
  taxdeclarecorrect_employee,
  taxdeclarecorrect_setresignation,
} from "@/http/taxdeclarecorrect";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive({
      model: {},
      month_data: [],
      params: {},
      selectItem: {},
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      taxdeclarecorrect_detail(props.data?.id).then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });

      taxdeclarecorrect_taxmonth(props.data?.id).then((res) => {
        if (res.status == 200)
          state.month_data = res.data.data?.skssq_list || [];
        if (state.month_data.length > 0) {
          state.active_month = state.month_data[0].skssq;
          onLoadEmployee(state.active_month);
        }
      });
    };

    const onLoadEmployee = (skssq) => {
      taxdeclarecorrect_employee({
        tax_declare_correct_id: props.data?.id,
        skssq,
      }).then((res) => {
        if (res.status == 200) {
          const { list, sortFields } = res.data.data;
          state.employee_data = list;
          state.sortFields = sortFields;
        }
      });
    };

    const onEditConfirm = (item) => {
      state.selectItem = item;
      state.showChange = false;
      if (state.employee_index != null && state.gzIndex != null)
        state.employee_data[state.employee_index].payroll_list[
          state.gzIndex
        ].origin_data = item;
    };

    //当月不申报
    const onDybsbChange = (item, checked) => {
      if (checked) {
        ElMessageBox.confirm(
          `您确定将人员<strong style='color:#080'>${item.name}</strong><strong style='color:#080'>置为</strong>当月不申报状态？`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            taxdeclarecorrect_setresignation({
              tax_declare_correct_id: props.data?.id,
              skssq: item.skssq,
              employee_id: item.employee_id,
              is_resignation: 1,
            }).then((res) => {
              if (res.status == 200) {
                ElMessage({
                  type: "success",
                  message: "操作成功！",
                  grouping: true,
                });
                item.is_resignation = item.is_resignation == 0 ? 1 : 0;
                state.key = Math.random();
              }
            });
          })
          .catch(() => {
            state.key = Math.random();
          });
      } else {
        ElMessageBox.confirm(
          `您确定将人员<strong style='color:#080'>${item.name}</strong><strong style='color:#f00'>取消</strong>当月不申报状态？`,
          "提示",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          taxdeclarecorrect_setresignation({
            tax_declare_correct_id: props.data?.id,
            skssq: item.skssq,
            employee_id: item.employee_id,
            is_resignation: 0,
          }).then((res) => {
            if (res.status == 200) {
              ElMessage({
                type: "success",
                message: "操作成功！",
                grouping: true,
              });
              item.is_resignation = item.is_resignation == 0 ? 1 : 0;
              state.key = Math.random();
            }
          });
        });
      }
    };

    return { state, props, onLoad, onEditConfirm, onDybsbChange };
  },
};
</script>
<style scoped lang="less"></style>
